import type { ViewQueryRecordNode } from '@salescore/core'

import { VIEW_NEW_RECORD_PREFIX } from '../../domain/constant'
import type { DeepReadonly } from '../types/DeepReadonly'

export function isNewRecord(record: ViewQueryRecordNode | DeepReadonly<ViewQueryRecordNode>): boolean {
  return record.id === undefined || record.id.startsWith(VIEW_NEW_RECORD_PREFIX)
}
